module.exports = __webpack_public_path__ + "media/entities/1105-bfbad58f.png";